import React, { Component, Fragment } from 'react';

import FooterDesktop from '../components/common/FooterDesktop';
import FooterMobile from '../components/common/FooterMobile';
import NavMenuDesktop from '../components/common/NavMenuDesktop';
import NavMenuMobile from '../components/common/NavMenuMobile';
import NewsletterSubscribe from '../components/others/NewsletterSubscribe';

class NewsletterSubscribePage extends Component {

  render() {

    return (

      <Fragment>

        {/* Desktop Navigation */}
        <div className="Desktop">
          <NavMenuDesktop />
        </div>

        {/* Mobile Navigation */}
        <div className="Mobile">
          <NavMenuMobile />
        </div>

        {/* Main Content */}
        <NewsletterSubscribe/>

        {/* Desktop Footer */}
        <div className="Desktop">
          <FooterDesktop />
        </div>

        {/* Mobile Footer */}
        <div className="Mobile">
          <FooterMobile />
        </div>

      </Fragment>

    );

  }

}

export default NewsletterSubscribePage;